import type { JSX, ReactNode } from 'react';
import { HypersolidFullLogoWhite } from '../../assets/logos/index.js';
import * as styles from './BrandHeader.css.js';
export function BrandHeader({
  children,
  alignment,
}: {
  children?: ReactNode;
  alignment?: 'content' | 'workspace';
}): JSX.Element {
  return (
    <header className={alignment ? styles.alignedHeader[alignment] : styles.header}>
      <div className={styles.brand}>
        <span className={styles.name}>SolidOps</span>
        <small className={styles.subtitle}>OPERATIONS</small>
      </div>
      {children}
      <HypersolidFullLogoWhite
        className={styles.partner}
        role="img"
        aria-label="Hypersolid"
        focusable="false"
      />
    </header>
  );
}
